import { Component, OnInit } from '@angular/core';
import {Router,ActivatedRoute} from "@angular/router";

@Component({
  selector: 'app-verifyfail',
  templateUrl: './verifyfail.component.html',
  styleUrls: ['./verifyfail.component.scss']
})
export class VerifyfailComponent implements OnInit {
  productValue = null;
  constructor(private router:Router,) { }

  ngOnInit(): void {

    
    this.productValue = window.localStorage.getItem('productValue');

    
  }
backtohome() {
    this.router.navigateByUrl('')
  }
}
